import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getSection } from 'actions/sections';
import Moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Editor } from 'UI/Inputs';
import { Spinner } from 'UI';
import { Button, Checkbox } from '@haldor/ui';

var UpdateMeeting = /*#__PURE__*/function (_Component) {
  _inherits(UpdateMeeting, _Component);

  var _super = _createSuper(UpdateMeeting);

  function UpdateMeeting(props) {
    var _this;

    _classCallCheck(this, UpdateMeeting);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.initialValues != null && _this.props.creating) {
        var foundStudentLed = _this.props.initialValues.instances.findIndex(function (instance) {
          return instance.studentLed == true;
        });

        _this.setState({
          studentLed: foundStudentLed > -1
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        if (_this.props.creating) {
          values.instances.forEach(function (instance) {
            instance.studentLed = _this.state.studentLed;
            return instance;
          });
        } else {
          values.instances = [];
        }

        values.status = _this.props.initialValues.status;

        if (_this.props.onSubmit) {
          _this.props.onSubmit(values).then(function () {
            resolve(1);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdate", function (selectedUsers) {
      _this.setState({
        selectedUsers: selectedUsers
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          margintop: '1rem',
          color: 'red'
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          margintop: '1rem',
          color: 'red'
        }
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value != 'undefined' && value != '' && value != null) {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate('field-max-200-chars');
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _this.state = {
      sectionId: 0,
      date: Moment(),
      error: null,
      selectedUsers: [],
      studentLed: false
    };
    return _this;
  }

  _createClass(UpdateMeeting, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          valid = _this$props.valid;

      if (submitting) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('title'), "*"), /*#__PURE__*/React.createElement(Field, {
        name: "title",
        type: "text",
        component: this.renderInput,
        placeholder: this.props.translate('title'),
        validate: this.required
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row input"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Information-to-participants')), /*#__PURE__*/React.createElement(Field, {
        component: Editor,
        name: "description",
        placeholder: this.props.translate('describe-meeting'),
        style: {
          margin: 0
        },
        translate: this.props.translate
      })), this.props.services.teamsMeeting ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('create-teamsmeeting')), /*#__PURE__*/React.createElement(Field, {
        component: Checkbox,
        name: "onlineMeeting",
        label: this.props.translate('create-teamsmeeting-for-this-meeting')
      })) : null, this.props.creating ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('studentled')), /*#__PURE__*/React.createElement(Checkbox, {
        value: this.state.studentLed,
        onChange: function onChange(value) {
          return _this2.setState({
            studentLed: value
          });
        },
        label: this.props.translate('studentled-meeting')
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid
      }, this.props.translate('save')))));
    }
  }]);

  return UpdateMeeting;
}(Component);

function mapStateToProps(state) {
  var meeting = state.Meetings.meeting;

  if (meeting == null && state.Meetings.wizardMeeting != null) {
    meeting = state.Meetings.wizardMeeting;
  }

  return {
    translate: translate(state.Languages.translations),
    initialValues: meeting,
    services: state.Services.availableServices,
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps, {
  getSection: getSection
})(reduxForm({
  form: 'UpdateMeeting',
  destroyOnUnmount: true
})(UpdateMeeting));